export default __webpack_public_path__ + "static/angular-icon-0ba48db3d45e6c4299283f0a56e89dd7.svg";